import React from 'react';
import IUrl from '../../../../types/IUrl';
import IForm from '../../../../types/IForm';
import Form from '../../../../components/molecules/Form/Form';
import { PageToPageEditFormTemplate } from './PageToPageEditFormTemplate';

type PageToPageEditFormProps = {
  templatedPreview: IUrl;
  templatedGetAllAllowedRoles?: IUrl;
  form: IForm;
  pageId: string;
  onSuccess: () => void;
};

export function PageToPageEditForm({
  templatedPreview,
  templatedGetAllAllowedRoles,
  form,
  pageId,
  onSuccess,
}: PageToPageEditFormProps) {
  return (
    <Form id="page-to-page-edit-form" model={form} onSuccess={onSuccess}>
      <PageToPageEditFormTemplate
        templatedPreview={templatedPreview}
        templatedGetAllAllowedRoles={templatedGetAllAllowedRoles}
        form={form}
        pageId={pageId}
      />
    </Form>
  );
}
